//--------------------------------------------
//swizzblocker
//--------------------------------------------

// check country
// let country = window.Shopify.country
// let isSwitzerland = country == "CH"
// console.log("Swizzblocker" + isSwitzerland)

// let variantID_restrictSwizerland = 45003217273097
// let variantIDs_disalowSwizerland = [45003217305865, 45003217338633, 45060118315273]
// let variantIDs_swizzToBeRemoved = []

// let swizzErrorMessage = "Der XXL Ramdan Kalender kann nur als einzel Produkt in die Schweiz bestellt werden."
// let swizzButtonMessage = "Warenkorb aktualisieren"

// function swizzblocker(cartItems) {
//   console.log("Swizzblocker")

//   if (cartItems == null || !isSwitzerland) return false

//   // let restrictItems = cartItems.filter((item) => item.variant_id == variantID_restrictSwizerland)
//   // let disalowItems = cartItems.filter((item) => variantIDs_disalowSwizerland.includes(item.variant_id))

//   variantIDs_swizzToBeRemoved = [];
//   let restrictItems = [];
//   let disalowItems = [];
//   let otherItems = [];
//   Object.values(cartItems).forEach((item) => {
//     if (item.variant_id == variantID_restrictSwizerland) {
//       restrictItems.push(item);
//     } else if (variantIDs_disalowSwizerland.includes(item.variant_id)) {
//       disalowItems.push(item);
//       variantIDs_swizzToBeRemoved.push(item.variant_id)
//     } else {
//       otherItems.push(item);
//       variantIDs_swizzToBeRemoved.push(item.variant_id)
//     }
//   })
//   console.log("restrictItems", restrictItems);
//   console.log("disalowItems", disalowItems);
//   console.log("otherItems", otherItems);

//   if ((restrictItems.length == 0 || (restrictItems.length == 1 && otherItems.length == 0)) && disalowItems.length == 0) return false
//   console.log("Swizzblocker active");

//   // create array with all cart items exept the restrictItem
//   removeBtn = document.getElementById("removeOtherProducts")
//   if (removeBtn) removeBtn.addEventListener("click", swizz_setItems)
//   //removeBtn.innerHTML = swizzButtonMessage;

//   return true
// }

// function swizz_setItems() {
//   fetchSetCartSwizz(variantIDs_swizzToBeRemoved, variantID_restrictSwizerland)
//   document.getElementById("preorderWarning").style.display = "none"
// }

// const fetchSetCartSwizz = async (variantIds_removed, variantId_setToOne) => {
//   try {
//     const cartUpdates = {
//       updates: {},
//     }
//     // console.log('fetchUpdateCartArray got:');
//     // console.log(variantIds);

//     variantIds.forEach((variantIds_removed) => {
//       cartUpdates.updates[variantIds_removed] = 0
//     })
//     cartUpdates.updates[variantId_setToOne] = 1

//     // console.log(cartUpdates);

//     const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(cartUpdates),
//     })

//     if (response.ok) {
//       // console.log('cool');
//       const event = new CustomEvent("cart:refresh", { bubbles: true })
//       document.documentElement.dispatchEvent(event)
//     } else {
//       throw new Error("Network response was not ok")
//     }

//     return response.ok
//   } catch (error) {
//     console.error("Error:", error)
//     return false
//   }
// }

//--------------------------------------------
//swizzblocker end
//--------------------------------------------

// console.log("Start PreorderBlocker");

var cartItems
var preorderItems
var otherItems

var checkoutBtn
var removeBtn

async function initPreorderBlocker() {
  // console.log('initPreorderBlocker');

  // Get Items
  cartItems = await getCartItems()

  // first do swizzblocker
  //if (swizzblocker(cartItems)) return;
  console.log("Swizzblocker not active");
  console.log("run PreorderBlocker");

  //than check for preorder
  preorderItems = []
  otherItems = []

  if (cartItems == null) return console.log('kein warenkorb');;
  Object.values(cartItems).forEach((item) => {
    if (item.product_type == "pre-order") {
      preorderItems.push(item.variant_id)
    } else otherItems.push(item.variant_id)
  })

  if (preorderItems.length == 0 || otherItems.length == 0) return console.log("kein mix warenkorb");

  removeBtn = document.getElementById("removeOtherProducts")
  if (removeBtn) {
    //removeBtn.onclick = removeOtherItems;
    setTimeout(() => {
      removeBtn.addEventListener("click", removeOtherItems);
    }, 100)
    //removeBtn.addEventListener("click", removeOtherItems)
    console.log("removeOtherProducts-Button found - atached listener")
  }
  else console.log("removeOtherProducts-Button not found");
}

const getCartItems = async () => {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart.js")
    const jsonData = await response.json()
    // console.log(jsonData.items);
    return jsonData.items
  } catch (error) {
    console.error("Error:", error)
    return false
  }
}

function removeOtherItems() {
  console.log("running removeOtherItems")
  fetchUpdateCartArray(otherItems, 0)
  document.getElementById("preorderWarning").style.display = "none"
}

const fetchUpdateCartArray = async (variantIds, quantity) => {
  try {
    const cartUpdates = {
      updates: {},
    }
    // console.log('fetchUpdateCartArray got:');
    // console.log(variantIds);

    variantIds.forEach((variantIds) => {
      cartUpdates.updates[variantIds] = quantity
    })

    // console.log(cartUpdates);

    const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cartUpdates),
    })

    if (response.ok) {
      // console.log('cool');
      const event = new CustomEvent("cart:refresh", { bubbles: true })
      document.documentElement.dispatchEvent(event)
    } else {
      throw new Error("Network response was not ok")
    }

    return response.ok
  } catch (error) {
    console.error("Error:", error)
    return false
  }
}

addEventListener("DOMContentLoaded", (event) => {
  initPreorderBlocker()
})
addEventListener("cart:refresh", (event) => {
  initPreorderBlocker()
})

class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges()
    })
  }

  async fetchCart() {
    const response = await fetch("/cart.js")
    return response.json()
  }

  storeCart(cart) {
    localStorage.setItem("cart", JSON.stringify(cart))
  }

  storedCart() {
    return JSON.parse(localStorage.getItem("cart")) || { items: [] }
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter((li) => !r.some((ri) => li.key == ri.key))
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    }

    oldCart.items.forEach((oi) => {
      const ni = newCart.items.find((i) => i.key == oi.key && i.quantity != oi.quantity)
      if (!ni) return
      let quantity = ni.quantity - oi.quantity
      let item = { ...ni }
      item.quantity = Math.abs(quantity)
      quantity > 0 ? result.added.push(item) : result.removed.push(item)
    })

    return result
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart()
    const oldCart = this.storedCart()
    const changes = this.findCartChanges(oldCart, newCart)

    const event = new CustomEvent("cart_changed", { detail: changes })
    window.dispatchEvent(event)

    this.storeCart(newCart)
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ["xmlhttprequest", "fetch"].includes(entry.initiatorType)
        const isCartChangeRequest = /\/cart\//.test(entry.name)
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges()
        }
      })
    })
    cartObserver.observe({ entryTypes: ["resource"] })
  }
}

const myCartWatcher = new CartWatcher()
myCartWatcher.init()
window.addEventListener("cart_changed", (e) => {
  initPreorderBlocker()
})
